import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export const useBreadcrumbMobile = (onClose) => {
  const location = useLocation();
  useEffect(() => {
    onClose();
  }, [location, onClose]);
};
